import { createSlice } from '@reduxjs/toolkit'
import AuthService from '../services/auth.service'
import TokenService from '../services/token.service'
import createAsyncThunkMiddleware from '../utils/helpers/createAsyncThunkMiddleware'

/**
 * body - {username, password}
 */
export const login = createAsyncThunkMiddleware('auth/login', AuthService.login)

/**
 * ()
 */
export const logout = createAsyncThunkMiddleware(
  'auth/logout',
  AuthService.logout,
)

export const newUserPassword = createAsyncThunkMiddleware(
  'auth/newUserPassword',
  AuthService.newPassword,
)

const initialState = {}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        if (action.payload?.resp)
          TokenService.setJWT(action.payload?.resp?.tokens)
        return action.payload.resp
      })
      .addCase(logout.fulfilled, () => {
        TokenService.removeJWT()
        return initialState
      })
      .addCase(login.rejected, () => {
        return initialState
      })
      .addCase(logout.rejected, () => {
        return initialState
      })
  },
})

export default authSlice.reducer
